import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import * as React from 'react'
import { PositionCard, PositionCardProps } from '../PositionCard'

export const DraggablePositionCard: React.FC<PositionCardProps> = (props) => {
  const { position } = props
  const {
    setNodeRef,
    attributes,
    listeners,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: `pos-${position.id}`,
    data: { id: position.id },
  })

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0 : 1,
    cursor: 'grab',
  }

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <PositionCard {...props} />
    </div>
  )
}
